import CourseCardV2ListItem from "./CourseCardV2ListItem";
import { ICourseCardV2List } from "./interfaces";

const CourseCardV2List = (props: ICourseCardV2List) => {
  if (!props || !props.items.length) {
    return (
      <p className="text-xl font-bold h-[40vh] flex items-center justify-center">
        No Courses Found
      </p>
    );
  }
  return <div className="space-y-4">
    {
      props.items.map((item, index) => (
        <CourseCardV2ListItem  category={props.category} key={index.toString()} item={item} />
      ))
    }
  </div>
};

export default CourseCardV2List;